module.exports = __webpack_public_path__ + "img/view-tree.3adc248a.png";